import generateCustomerToken from './generateCustomerToken.gql'
import createCustomerV2 from './createCustomerV2'
import requestPasswordResetEmail from './requestPasswordResetEmail'
import changeCustomerPassword from './changeCustomerPassword'
import revokeCustomerToken from './revokeCustomerToken'
import MJresetPassword from './MJresetPassword'
import customerCart from './customerCart'
import mergeCarts from './mergeCarts'
import updateCustomerEmail from './updateCustomerEmail'
import updateCustomer from './updateCustomer'
import customer from './customer'
import addProductsToCart from './addProductsToCart'
import addProductsToWishlist from './addProductsToWishlist'
import wishlist from './wishlist'
import removeProductsFromWishlist from './removeProductsFromWishlist'
import addWishlistItemsToCart from './addWishlistItemsToCart'
import updateProductsInWishlist from './updateProductsInWishlist'
import updateCartItems from './updateCartItems'
import removeItemFromCart from './removeItemFromCart'
import applyCouponToCart from './applyCouponToCart'
import removeCouponFromCart from './removeCouponFromCart'
import cart from './cart'
import customerCartComplete from './customerCartComplete'
import createEmptyCart from './createEmptyCart'
import cartTotalQty from './cartTotalQty'
import createProductReview from './createProductReview'
import productsList from './productsList'
import productDetails from './productDetails'
import categoryList from './categoryList'
import cmsBlocks from './cmsBlocks'
import productReview from './productReview'
import productReviewRatingsMetadata from './productReviewRatingsMetadata'
import relatedProduct from './relatedProduct'
import upsellProducts from './upsellProducts'
import customAttributeMetadata from './customAttributeMetadata'
import orderDetails from './orderDetails'
import categoryHreflangs from './categoryHreflangs'
import orderDetailsCompleteItems from './orderDetailsCompleteItems'
import customerOrders from './customerOrders'
import customerOrdersSimplified from './customerOrdersSimplified'

const apiMethods = {
  post: {
    addProductsToCart,
    addProductsToWishlist,
    addWishlistItemsToCart,
    applyCouponToCart,
    createEmptyCart,
    createProductReview,
    generateCustomerToken,
    createCustomerV2,
    requestPasswordResetEmail,
    changeCustomerPassword,
    revokeCustomerToken,
    MJresetPassword,
    mergeCarts,
    removeCouponFromCart,
    removeItemFromCart,
    removeProductsFromWishlist,
    updateCartItems,
    updateCustomerEmail,
    updateCustomer,
    updateProductsInWishlist,
  },
  get: {
    cart,
    cartTotalQty,
    categoryList,
    cmsBlocks,
    customAttributeMetadata,
    customer,
    customerOrders,
    customerOrdersSimplified,
    customerCart,
    customerCartComplete,
    orderDetails,
    orderDetailsCompleteItems,
    productDetails,
    productsList,
    productReview,
    productReviewRatingsMetadata,
    relatedProduct,
    upsellProducts,
    wishlist,
    categoryHreflangs,
  },
}

export type PostApiMethods = keyof typeof apiMethods.post
export type GetApiMethods = keyof typeof apiMethods.get

export default apiMethods
